import {RouteObject} from 'react-router';
import {notSubscribedGuard} from '@common/auth/guards/not-subscribed-route';
import {auth} from '@common/auth/use-auth';
import {
  getGuestRegistration,
  storeGuestRegistration,
} from '@common/billing/checkout/guest-registration';

const lazyRoute = async (
  cmp: keyof typeof import('@common/billing/checkout/routes/checkout-routes.lazy'),
) => {
  const exports = await import(
    '@common/billing/checkout/routes/checkout-routes.lazy'
  );
  return {
    Component: exports[cmp],
  };
};

export const checkoutRoutes: RouteObject[] = [
  {
    path: 'checkout/:productId/:priceId',
    loader: ({params, request}) => {
      // paid sign-up: no account yet, only a pending registration
      if (!auth.isLoggedIn) {
        // link opened from the mobile app
        const token = new URL(request.url).searchParams.get('registration');
        if (token && params.productId && params.priceId) {
          storeGuestRegistration({
            token,
            productId: parseInt(params.productId),
            priceId: parseInt(params.priceId),
          });
        }
        if (getGuestRegistration(params.productId, params.priceId)) {
          return null;
        }
      }
      return notSubscribedGuard();
    },
    lazy: () => lazyRoute('Checkout'),
  },
  {
    path: 'checkout/:productId/:priceId/stripe/done',
    lazy: () => lazyRoute('CheckoutStripeDone'),
  },
  {
    path: 'checkout/:productId/:priceId/paypal/done',
    lazy: () => lazyRoute('CheckoutPaypalDone'),
  },
  {
    path: 'checkout/:productId/:priceId/mpesa/done',
    lazy: () => lazyRoute('CheckoutMpesaDone'),
  },
];
